import React from 'react'
import { Moon, Sun } from 'react-bootstrap-icons'

export default function ThemeToggleButton({
  isDark,
  onToggle,
  darkTitle = 'Light mode',
  lightTitle = 'Dark mode',
  className = '',
}) {
  return (
    <button
      type="button"
      className={`cursor-pointer flex justify-center items-center h-9 w-9 rounded-full p-0 border-0 active:shadow-outer active:shadow-gray-400 text-rb-black dark:text-white hover:opacity-80 ${className}`}
      onClick={onToggle}
      title={isDark ? darkTitle : lightTitle}
      aria-label={isDark ? darkTitle : lightTitle}
    >
      {isDark ? <Sun /> : <Moon />}
    </button>
  )
}
